<template>
  <div class="upload-file">
    <file-upload
      :multiple="true"
      :accept="acceptType"
      :before-upload="fileUploadBefore"
      :on-success="fileUploadSuccess"
      :on-error="handleError"
    >
      <div ref="uploadRef"></div>
    </file-upload>
  </div>
</template>
<script setup>
import FileUpload from '@/components/upload/file-upload'
import { ElMessage } from 'element-plus'
import { getCurrentInstance, reactive, computed, ref, defineExpose, defineEmits } from 'vue'
const { proxy } = getCurrentInstance()
const emit = defineEmits(['sendCurMsg', 'send', 'error'])
const page = reactive({
  uploadUrl: `${proxy.$config.baseURL}/sys/oss/upload`,
  uploadConfig: {}, //上传配置
  uploadType: 1, //上传类型
  msgId: null //消息ID
})
const acceptType = computed(() => {
  if ([3, 6].includes(page.uploadType)) {
    return '.jpeg,.jpg,.gif,.png,.webp,.ico,.mp4,.webm,.ts,.avi,.mov,.wmv,.m4v'
  } else if (page.uploadType === 4) {
    return '.pdf,.ppt,pptx,.txt,.xls,.xlsx,.doc,.docx'
  }
  return ''
})
// 获取上传配置
const getUploadConfig = async () => {
  let res = await proxy.$http.post('/sys/config/getOnlineFileConfig')
  if (res.code === 0) {
    page.uploadConfig = res.data || {}
  } else {
    ElMessage.error(res.msg)
  }
}
getUploadConfig()
// 固定的文件type字典
const fileUploadTypeEnums = {
  image: 'image/jpeg,image/jpg,image/gif,image/png,image/webp,image/ico',
  pdf: 'application/pdf',
  excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
  ppt: 'application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.ms-powerpoint',
  word: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword',
  txt: 'text/plain',
  video: 'video/mp4,video/webm,video/ts,video/avi,video/mov,video/wmv,video/m4v,video/quicktime'
}
// 上传文件校验
const fileUploadBefore = (file) => {
  if (Object.keys(page.uploadConfig).length === 0) return true

  let flag = false,
    fileType
  for (let key in fileUploadTypeEnums) {
    if (fileUploadTypeEnums[key].includes(file.type)) {
      flag = true
      fileType = key
    }
  }
  if (!flag) {
    ElMessage.error(`请上传符合格式的文件！`)
    return false
  }
  let size = file.size / 1024 / 1024
  if (fileType === 'image') {
    fileType = 3
  } else if (['pdf', 'excel', 'ppt', 'pptx', 'word', 'txt'].includes(fileType)) {
    fileType = 4
  } else if (fileType === 'video') {
    fileType = 6
  }
  let { pictureSet, fileSet, videoSet } = page.uploadConfig
  if (fileType === 3 && size > pictureSet.limitSize) {
    ElMessage.error(`上传的图片不能大于${pictureSet.limitSize}MB!`)
    return false
  }
  if (fileType === 4 && size > fileSet.limitSize) {
    ElMessage.error(`上传的文件不能大于${fileSet.limitSize}MB!`)
    return false
  }
  if (fileType === 6 && size > videoSet.limitSize) {
    ElMessage.error(`上传的视频不能大于${videoSet.limitSize}MB!`)
    return false
  }
  sendCurrentMsg(file, fileType)
  return true
}
// 提前上传图片
const sendCurrentMsg = (file, fileType) => {
  page.msgId = new Date().getTime()
  if (fileType === 3) {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = (e) => {
      let content = {
        url: e.target.result,
        name: file.name,
        size: file.size
      }
      emit('sendCurMsg', fileType, page.msgId, content)
      content = null
    }
  } else {
    let content = {
      name: file.name,
      url: '',
      size: file.size
    }
    emit('sendCurMsg', fileType, page.msgId, content)
    content = null
  }
}
// 点击上传
const uploadRef = ref(null)
const handleUploadClick = (type) => {
  page.uploadType = type
  uploadRef.value?.click()
}
// 上传成功回调
const fileUploadSuccess = (res) => {
  if (res.code === 0) {
    let obj = {
      3: 'jpeg,jpg,gif,png,webp,ico',
      4: 'pdf,ppt,pptx,txt,xls,xlsx,doc,docx',
      6: 'mp4,webm,ts,avi,mov,wmv,m4v'
    }
    let response = res.data,
      type
    let content = {
      name: response.name,
      url: response.url,
      size: response.size
    }
    for (let key in obj) {
      if (obj[key].includes(response.suffix)) {
        type = key
      }
    }
    let url = response.url
    emit('send', type, JSON.stringify(content), url, page.msgId)
  } else {
    handleError()
  }
}
// 上传失败回调
const handleError = () => {
  ElMessage.error('文件上传失败! 请检查网络')
  emit('error', page.msgId)
}
defineExpose({
  handleUploadClick
})
</script>
<style lang="less" scoped>
.upload-file {
}
</style>
